/* eslint-disable @next/next/no-img-element */
import { useImagePreload } from '@/hooks/ImagePreloader';
import { classnames } from '@/utils/classnames';

interface LazyImageProps extends React.HTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  className,
  ...rest
}) => {
  const { isLoaded, isError } = useImagePreload(src);

  if (isError) return <div className={className} />;

  if (!isLoaded)
    return <div className={classnames('animate-pulse', className)} />;

  return <img alt={alt} className={className} src={src} {...rest} />;
};

export default LazyImage;
